module.exports = __webpack_public_path__ + "static/media/dsr_cer4.0688e98a.svg";